import script from "./InternalApprovalManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalApprovalManagement.vue?vue&type=script&setup=true&lang=js"

import "./InternalApprovalManagement.vue?vue&type=style&index=0&id=fd17999c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd17999c"]])

export default __exports__